export const ElectricLine = ({ className }) => {
  return (
    <svg
      width="24"
      className={className}
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0754 1.93405L11.9244 24.6668M2.12824 5.27808L21.9772 5.40986M3.13578 3.01139L3.12069 5.28467M7.10557 3.03775L7.09048 5.31103M17.0301 3.10364L17.015 5.37691M20.9998 3.12999L20.9848 5.40327M18.9999 5.39009L11.9999 13.3004L5.10558 5.29785"
        stroke="#827575"
        stroke-width="2.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Cactus = ({ className }) => {
  return (
    <svg
      width="44"
      className={className}
      height="45"
      viewBox="0 0 44 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_93_720)">
        <path
          d="M17.2775 29.5495C12.4559 26.6679 7.25697 24.481 8.00666 19.5837C8.25711 17.9482 11.0345 23.4759 14.4909 25.9876C12.7602 23.2428 10.58 19.6061 11.6812 15.9784C12.1598 14.4043 14.455 23.5582 15.6504 24.8212C15.234 23.0846 13.419 15.8163 16.4242 13.9044C17.8106 13.0226 16.9247 23.5748 16.9247 23.5748C16.9247 23.5748 17.7746 14.4574 20.9986 13.4402C22.3022 13.0294 17.9869 22.3502 18.6916 25.3743C18.6916 25.3743 24.3081 13.9304 25.9309 14.9745C27.5537 16.0187 23.0621 22.7055 20.1854 26.4155C24.4381 24.2721 28.3003 18.6968 29.4406 18.337C30.5809 17.9772 28.5738 23.7689 22.1673 26.857C24.3448 27.6377 32.2443 21.2771 31.5716 22.7344C29.3707 27.5021 22.3722 28.6157 22.3722 28.6157C26.0468 29.3241 31.718 26.9125 31.9585 27.9486C32.199 28.9847 25.9567 31.576 20.7719 29.9662C26.1133 33.0842 31.452 31.4138 30.6878 32.62C28.4634 36.1261 22.0991 32.4312 17.2775 29.5495Z"
          fill="#583A37"
        />
      </g>
      <defs>
        <clipPath id="clip0_93_720">
          <rect
            width="30"
            height="34"
            fill="white"
            transform="translate(17.4424) rotate(30.8647)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const StopSign = ({ className }) => {
  return (
    <svg
      width="100%"
      height="100%"
      className={className}
      viewBox="0 0 30 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_88_16)">
        <path
          d="M0.511053 1.51111C-0.324748 1.51111 -1 2.18636 -1 3.02216L-1 21.1548C-1 21.9906 -0.324748 22.6659 0.511053 22.6659C1.34685 22.6659 2.02211 21.9906 2.02211 21.1548L2.02211 12.5749L6.04528 4.53321L2.02211 4.53321V3.02216C2.02211 2.18636 1.34685 1.51111 0.511053 1.51111ZM18.1337 4.53321L14.6205 4.53321L14.3655 5.03847L10.0874 13.5995H13.5958L13.8508 13.0943L18.1337 4.53321ZM16.1316 13.5995H19.64L19.895 13.0943L24.1779 4.53321H20.6647L20.4097 5.03847L16.1316 13.5995ZM8.5763 4.53321L8.32131 5.03847L4.04314 13.5995L7.55162 13.5995L7.80661 13.0943L12.0895 4.53321H8.5763ZM22.1758 13.5995H26.199V21.1548C26.199 21.9906 26.8742 22.6659 27.71 22.6659C28.5458 22.6659 29.2211 21.9906 29.2211 21.1548L29.2211 3.02216C29.2211 2.18636 28.5458 1.51111 27.71 1.51111C26.8742 1.51111 26.199 2.18636 26.199 3.02216V5.5579L22.1758 13.5995Z"
          fill="#FFA500"
        />
      </g>
      <defs>
        <clipPath id="clip0_88_16">
          <rect
            width="30.2211"
            height="24.1768"
            fill="white"
            transform="translate(-1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DesertPlant = ({ className }) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0599 2.14722H16.4349C17.4012 2.1473 18.3278 2.5312 19.011 3.21447C19.6942 3.89773 20.0781 4.82441 20.0781 5.79065V28.5669C20.0781 28.908 19.9426 29.235 19.7014 29.4762C19.4603 29.7174 19.1332 29.8528 18.7921 29.8528H13.7024C13.3614 29.8528 13.0343 29.7174 12.7931 29.4762C12.552 29.235 12.4165 28.908 12.4165 28.5669V5.79065C12.4165 4.82435 12.8004 3.89763 13.4836 3.21435C14.1669 2.53108 15.0936 2.14722 16.0599 2.14722Z"
        fill="#4C9589"
      />
      <path
        d="M13.2499 23.5C11.5659 23.5 9.13993 23.225 7.52212 20.8456C6.23618 18.9547 5.63712 15.9428 5.63712 11.3672C5.63399 11.1309 5.67783 10.8964 5.76609 10.6771C5.85436 10.4579 5.98528 10.2584 6.15127 10.0902C6.31726 9.92203 6.51501 9.78848 6.73304 9.69732C6.95106 9.60616 7.18502 9.55922 7.42134 9.55922C7.65765 9.55922 7.89161 9.60616 8.10964 9.69732C8.32767 9.78848 8.52541 9.92203 8.6914 10.0902C8.85739 10.2584 8.98832 10.4579 9.07658 10.6771C9.16484 10.8964 9.20868 11.1309 9.20556 11.3672C9.20556 15.0885 9.63181 17.6025 10.4727 18.8391C10.9315 19.5135 11.5559 19.9328 13.2496 19.9328C13.4883 19.9258 13.7259 19.9666 13.9485 20.0531C14.1711 20.1395 14.3741 20.2697 14.5454 20.436C14.7167 20.6023 14.8529 20.8013 14.946 21.0213C15.039 21.2412 15.0869 21.4775 15.0869 21.7163C15.087 21.955 15.0391 22.1914 14.9461 22.4113C14.8531 22.6312 14.7169 22.8303 14.5456 22.9966C14.3743 23.1629 14.1714 23.2932 13.9488 23.3797C13.7263 23.4661 13.4886 23.5071 13.2499 23.5ZM18.8696 18.265C18.4005 18.2588 17.9527 18.0681 17.6232 17.7342C17.2936 17.4002 17.1089 16.95 17.1089 16.4808C17.1089 16.0117 17.2936 15.5614 17.6232 15.2274C17.9527 14.8935 18.4005 14.7028 18.8696 14.6966C20.4559 14.6966 21.3256 14.4444 21.8696 13.826C22.6412 12.951 23.0321 11.1022 23.0321 8.33252C23.029 8.09623 23.0728 7.86167 23.1611 7.64246C23.2494 7.42324 23.3803 7.22375 23.5463 7.05554C23.7123 6.88734 23.91 6.75379 24.128 6.66263C24.3461 6.57148 24.58 6.52454 24.8163 6.52454C25.0527 6.52454 25.2866 6.57148 25.5046 6.66263C25.7227 6.75379 25.9204 6.88734 26.0864 7.05554C26.2524 7.22375 26.3833 7.42324 26.4716 7.64246C26.5598 7.86167 26.6037 8.09623 26.6006 8.33252C26.6006 12.1 25.9481 14.595 24.5468 16.1853C22.9231 18.0285 20.6599 18.265 18.8696 18.265Z"
        fill="#4C9589"
      />
      <path
        d="M13.6953 5.47778H14.7441V8.10091H13.6953V5.47778Z"
        fill="white"
      />
      <path
        d="M7.25049 11.9252L8.29717 11.8594L8.46188 14.4773L7.4152 14.5432L7.25049 11.9252Z"
        fill="white"
      />
      <path
        d="M6.89673 16.3484L7.91129 16.0828L8.5756 18.6204L7.56104 18.886L6.89673 16.3484Z"
        fill="white"
      />
      <path
        d="M9.07471 20.4341L9.59908 19.5259L11.8708 20.8374L11.3464 21.7457L9.07471 20.4341Z"
        fill="white"
      />
      <path
        d="M22.9113 14.7535L23.3983 15.6824L21.0752 16.9005L20.5881 15.9717L22.9113 14.7535Z"
        fill="white"
      />
      <path
        d="M24.6386 11.6689L25.618 12.0439L24.6801 14.4936L23.7007 14.1187L24.6386 11.6689Z"
        fill="white"
      />
      <path
        d="M23.8729 8.0979L24.9171 8.19605L24.6716 10.8077L23.6274 10.7095L23.8729 8.0979Z"
        fill="white"
      />
      <path
        d="M13.6953 12.0793H14.7441V14.7025H13.6953V12.0793Z"
        fill="white"
      />
      <path
        d="M13.6953 18.7406H14.7441V21.3637H13.6953V18.7406Z"
        fill="white"
      />
      <path
        d="M13.6953 25.3425H14.7441V27.9657H13.6953V25.3425Z"
        fill="white"
      />
      <path d="M15.8662 3.45569H16.915V6.07881H15.8662V3.45569Z" fill="white" />
      <path d="M15.8662 10.0575H16.915V12.6806H15.8662V10.0575Z" fill="white" />
      <path d="M15.8662 16.7185H16.915V19.3416H15.8662V16.7185Z" fill="white" />
      <path d="M15.8662 23.3203H16.915V25.9434H15.8662V23.3203Z" fill="white" />
      <path d="M17.7693 6.07251H18.818V8.69563H17.7693V6.07251Z" fill="white" />
      <path d="M17.7693 12.6744H18.818V15.2976H17.7693V12.6744Z" fill="white" />
      <path d="M17.7693 19.3357H18.818V21.9588H17.7693V19.3357Z" fill="white" />
      <path d="M17.7693 25.9373H18.818V28.5604H17.7693V25.9373Z" fill="white" />
      <path
        d="M5.7356 7.83374C5.7356 7.83374 6.24997 10.25 7.47528 10.25C8.7006 10.25 9.34372 8.21874 9.34372 8.21874L8.24841 8.92749L7.34622 6.80249L6.89528 8.67093L5.7356 7.83374Z"
        fill="#F6B7C0"
      />
    </svg>
  );
};

export const PalmTree = ({ className }) => {
  return (
    <svg
      width="100%"
      height="100%"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_93_681)">
        <path
          d="M21.6263 6.12338C21.235 3.92518 19.5548 2.83899 17.49 2.98177C15.5884 3.1134 14.3792 5.34652 13.7827 6.71443C14.1051 4.85588 14.019 2.21799 11.9066 0.779024C8.68006 -1.41955 6.18697 1.69131 5.92854 2.10146C5.66928 2.51204 5.66028 2.59449 6.26979 2.61582C6.45111 2.62196 8.06557 2.33645 9.57917 2.7692L10.3716 2.17281L10.6137 3.14902C11.8459 3.72451 12.7565 4.97312 12.7688 6.71152C11.8598 5.3341 10.3437 4.35413 8.54468 4.17451C5.41498 3.86195 2.63229 6.07613 2.32793 9.11968C2.30412 9.3646 2.32625 9.18981 2.32625 9.18981C2.32381 9.30549 2.38943 9.41298 2.49364 9.46341C2.59864 9.51343 2.72337 9.49749 2.81276 9.42245C2.81276 9.42245 2.88495 9.33052 3.19507 9.09962C3.73981 8.6927 4.32964 8.34484 4.95232 8.06021L5.59142 7.1094L6.27889 7.56798C7.41261 7.24229 8.62512 7.12126 9.86961 7.24557C10.6917 7.3276 11.4776 7.51177 12.2192 7.78332C10.4767 7.49167 7.74322 8.14182 6.47408 10.2686C4.90142 12.904 5.95808 15.2261 6.12542 15.4161C6.26239 15.5724 6.45603 15.4805 6.53065 15.2401C6.69228 14.7146 7.09015 13.7421 7.74893 12.6723L7.61768 11.7588L8.21 11.975C9.10583 10.7079 10.3618 9.40885 12.0345 8.61596C10.7326 10.8609 9.50126 14.0723 9.88929 18.4424C6.52409 19.0458 3.96776 21.9061 3.96776 24H18.3604C18.3604 21.9712 15.9616 19.2226 12.7515 18.5039C12.0886 16.5834 11.6629 13.4714 13.2092 9.30591C13.5849 9.90601 14.0517 10.7682 14.411 11.7978L14.982 11.9286L14.6547 12.5943C14.8868 13.4734 15.0198 14.4422 14.9509 15.4586C14.9328 15.7175 15.069 15.9246 15.1658 15.7634C16.6466 13.2843 16.5284 10.584 14.973 8.85962C16.0157 9.32354 16.8106 10.2789 17.3988 11.3396L18.1995 11.5972L17.955 12.5058C18.421 13.656 18.6655 14.7733 18.7295 15.4062C18.7549 15.6556 18.8682 15.8279 19.0519 15.5654C20.1487 14.0013 20.5868 10.8331 19.0782 8.92402C17.9075 7.44451 15.6146 7.12581 14.1592 7.35793C15.247 5.88577 17.7492 6.01829 17.7492 6.01829C17.7492 6.01829 18.2331 5.15035 18.3325 5.02932C18.4317 4.90829 18.8058 5.96907 18.8058 5.96907L21.2112 7.24388C21.2112 7.24388 21.5114 7.49616 21.6115 7.1282C21.6722 6.90638 21.7296 6.56101 21.6263 6.12338Z"
          fill="#827E16"
        />
      </g>
      <defs>
        <clipPath id="clip0_93_681">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DesertPlant2 = ({ className }) => {
  return (
    <svg
      width="100%"
      className={className}
      height="100%"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7175 17.6645C17.6841 17.5698 18.9017 17.2331 20.0111 16.2951C21.8526 14.7362 22.7094 12.0875 22.5591 8.42264C22.5245 7.53272 21.7774 6.83973 20.8815 6.87731C19.9901 6.91339 19.2986 7.66351 19.3346 8.55493C19.4399 11.1164 18.9618 12.9354 17.9517 13.8117C17.5548 14.156 17.1114 14.3244 16.7175 14.4025C16.6033 8.27382 15.9283 2.03388 15.9283 2.03388C15.3962 0.517114 13.9485 0 13.2044 0H12.6452C11.9026 0 9.99653 0.861355 9.92137 2.03388C9.92137 2.03388 9.30504 9.68386 9.15021 14.371C8.79695 14.2838 8.41663 14.1214 8.07238 13.8328C7.04567 12.9624 6.55862 11.1375 6.66385 8.55493C6.70143 7.662 6.00844 6.91189 5.11702 6.87581C4.2241 6.83823 3.47699 7.53122 3.44091 8.42114C3.29059 12.086 4.14743 14.7347 5.98739 16.2936C7.04718 17.191 8.20467 17.5353 9.1472 17.6465C9.29452 21.2678 9.92287 24.623 9.92287 24.623C9.92287 24.8425 9.9815 25.0485 10.0747 25.2303C7.27567 25.4769 5.53191 26 5.53191 26H20.4711C18.8281 25.5971 17.2527 25.3611 15.7765 25.2333C15.8712 25.0484 15.9298 24.841 15.9298 24.623C15.9268 24.623 16.6033 23.0266 16.7175 17.6645Z"
        fill="#4C9589"
      />
    </svg>
  );
};

export const DesertStone = ({ className }) => {
  return (
    <svg
      width="100%"
      className={className}
      height="100%"
      viewBox="0 0 83 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.70711 0.792893C9.89464 0.605357 10.149 0.5 10.4142 0.5H19.5L30.2275 2.64551C33.0436 3.20871 35.9472 3.16602 38.7455 2.52027V2.52027C40.223 2.17931 41.7638 2.22914 43.2162 2.66486L52.0957 5.32871C54.6721 6.10162 57.3779 6.3469 60.0513 6.04986L65 5.5V5.5C70.4076 5.5 75.2419 8.87091 77.1113 13.9451L81 24.5H0V12.1708C0 8.26604 2.6952 4.87803 6.5 4V4L9.70711 0.792893Z"
        fill="url(#paint0_linear_150_189)"
      />
      <path
        d="M9.32366 2.45759C11.6536 3.75202 14.4375 3.94711 16.9253 2.99028L19.5 2L33.4056 1.59101C35.4635 1.53049 37.5104 1.26683 39.5165 0.803892V0.803892C41.7994 0.277062 44.1802 0.354058 46.4243 1.02729L54.0957 3.32871C56.6721 4.10162 59.3779 4.3469 62.0513 4.04986L67 3.5V3.5C72.4076 3.5 77.2419 6.87091 79.1113 11.9451L83 22.5H2V10.1708C2 6.26604 4.6952 2.87803 8.5 2V2L9.32366 2.45759Z"
        fill="url(#paint1_linear_150_189)"
      />
      <path
        d="M17.7934 9.19748C18.6684 8.419 19.8795 8.13943 21.0072 8.45558L39 13.5L53 18H16V13.1935C16 11.6666 16.6526 10.2124 17.7934 9.19748V9.19748Z"
        fill="#FFC93F"
      />
      <path
        d="M71.4751 14.4525C71.4154 14.6043 71.2909 14.7215 71.1357 14.7718V14.7718C66.4045 16.3062 61.2198 14.6968 58.189 10.7531L58.0001 10.5072L71.3115 7.99993L71.9877 11.5901C72.1173 12.278 72.0502 12.9885 71.7943 13.64L71.4751 14.4525Z"
        fill="#FFC93F"
      />
      <defs>
        <linearGradient
          id="paint0_linear_150_189"
          x1="40.5"
          y1="-2"
          x2="40.5"
          y2="24.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EFCC71" />
          <stop offset="1" stop-color="#DAAD3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_150_189"
          x1="42.5"
          y1="-4"
          x2="42.5"
          y2="22.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EFCC71" />
          <stop offset="1" stop-color="#DAAD3B" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Bridge = ({ className }) => {
  return (
    <svg
      width="100%"
      className={className}
      height="100%"
      viewBox="0 0 480 162"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.500095 0.5H479.5V92.9295C479.5 94.6005 477.18 95.0197 476.595 93.4543L457.27 41.7166C455.717 37.5575 451.715 34.825 447.276 34.8918L40.0921 41.0127C36.3181 41.0694 32.865 43.1473 31.0475 46.4552L3.31464 96.929C2.56749 98.2888 0.500006 97.7583 0.500007 96.2067L0.500095 0.5Z"
        fill="url(#paint0_linear_196_193)"
        stroke="#B3B3B3"
      />
      <mask id="path-2-inside-1_196_193" fill="white">
        <path d="M91.7715 34.1987H111.69V80.8335H91.7715V34.1987Z" />
      </mask>
      <path
        d="M91.7715 34.1987H111.69V80.8335H91.7715V34.1987Z"
        fill="#F2B720"
      />
      <path
        d="M110.69 34.1987V80.8335H112.69V34.1987H110.69ZM92.7715 80.8335V34.1987H90.7715V80.8335H92.7715Z"
        fill="#9B9595"
        mask="url(#path-2-inside-1_196_193)"
      />
      <mask id="path-4-inside-2_196_193" fill="white">
        <path d="M370.63 27.9807H390.549V74.6155H370.63V27.9807Z" />
      </mask>
      <path
        d="M370.63 27.9807H390.549V74.6155H370.63V27.9807Z"
        fill="#F2B720"
      />
      <path
        d="M389.549 27.9807V74.6155H391.549V27.9807H389.549ZM371.63 74.6155V27.9807H369.63V74.6155H371.63Z"
        fill="#979797"
        mask="url(#path-4-inside-2_196_193)"
      />
      <path
        d="M13.4377 111.534C12.6466 111.646 11.8661 111.878 11.1062 112.227C7.39548 113.998 -0.935834 118.732 5.75141 122.922C5.75141 122.922 21.0062 132.127 51.7735 131.723L115.615 134.727C115.615 134.727 133.001 132.391 162.34 133.581C162.34 133.581 200.304 138.06 228.637 119.544C228.637 119.544 238.54 112.842 244.55 111.882C244.55 111.882 266.423 102.769 256.326 88.2268C253.205 85.2848 249.731 83.5628 246.184 83.2008C245.062 83.1171 243.949 82.7318 242.891 82.0603C235.675 77.4347 207.484 60.5229 189.728 66.1817C189.728 66.1817 176.903 69.1534 167.074 65.9578L151.005 67.0476C151.005 67.0476 137.436 58.8646 121.552 67.0104C121.552 67.0104 95.5202 77.4347 84.3385 77.3115C84.3385 77.3115 15.7792 99.4123 5.7235 115.524C5.7235 115.524 31.4989 99.8808 25.4768 103.271C23.7771 104.22 22.133 105.399 20.5612 106.796C18.32 108.736 15.2227 111.228 13.4377 111.534Z"
        fill="url(#paint1_linear_196_193)"
      />
      <path
        d="M227.164 103.519C226.373 103.635 225.592 103.881 224.833 104.253C221.124 106.145 212.801 111.211 219.514 115.78C219.514 115.78 182.125 133.01 212.932 132.763L328.938 132.763C328.938 132.763 423.409 126.66 452.792 128.128C452.792 128.128 455.524 128.158 457.477 128.18C457.477 128.18 464.71 129.278 470.725 128.277C470.725 128.277 480.457 95.6087 470.288 79.8292C467.151 76.6301 463.665 74.7475 460.112 74.3343C458.988 74.2369 457.872 73.8136 456.81 73.0813C449.565 68.0373 428.244 69.6618 406.151 68.1775C406.151 68.1775 392.785 71.4326 382.931 67.918L366.995 67.7399C366.995 67.7399 344.81 62.9463 328.938 71.6523C328.938 71.6523 206.976 79.4493 195.779 79.2471C195.779 79.2471 161.197 76.5781 151.193 93.9296C151.193 93.9296 245.203 91.0359 239.186 94.6625C237.488 95.678 235.847 96.942 234.279 98.442C232.042 100.525 228.951 103.199 227.164 103.519Z"
        fill="url(#paint2_linear_196_193)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_196_193"
          x1="241.243"
          y1="-78"
          x2="241.243"
          y2="193.143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#CE8C12" />
          <stop offset="1" stop-color="#FFEBB9" stop-opacity="0.29" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_196_193"
          x1="41.9013"
          y1="98.0342"
          x2="148.372"
          y2="104.535"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C6E1F2" />
          <stop offset="1" stop-color="#2E9DDC" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_196_193"
          x1="269.279"
          y1="138.217"
          x2="680.777"
          y2="117.328"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2D9CDB" />
          <stop offset="0.958333" stop-color="#7FA4E3" />
          <stop offset="1" stop-color="#82A4E4" stop-opacity="0.79" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LittleWater = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 224 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.28322 25.7428C5.90012 25.7811 5.52139 25.8561 5.1519 25.9667C3.34706 26.5281 -0.71 28.0209 2.49559 29.2722C2.49559 29.2722 9.81032 32.0187 24.6842 31.7422L55.5227 32.3468C55.5227 32.3468 63.941 31.5446 78.1142 31.764C78.1142 31.764 96.4356 32.9489 110.248 27.1319C110.248 27.1319 115.077 25.0281 117.989 24.7039C117.989 24.7039 128.619 21.8017 123.831 17.3936C122.341 16.5071 120.673 15.9964 118.961 15.903C118.419 15.8829 117.884 15.7703 117.376 15.5697C113.918 14.1874 100.4 9.14238 91.7812 10.9652C91.7812 10.9652 85.5633 11.9398 80.8331 11.0089L73.9347 10.358C73.9347 10.358 66.5526 8.9812 58.8236 11.5572C58.8236 11.5572 46.1746 14.8821 40.7708 14.8997C40.7708 14.8997 24.0972 14.3743 19.1342 19.3635C19.1342 19.3635 15.0872 22.0808 12.1549 23.1499C11.3273 23.4493 10.5251 23.8189 9.75653 24.2549C8.66091 24.8608 7.14797 25.6401 6.28322 25.7428Z"
        fill="url(#paint0_linear_158_206)"
      />
      <path
        d="M103.9 24.4047C103.516 24.4413 103.137 24.5106 102.766 24.6118C100.957 25.1243 96.8872 26.4825 100.087 27.5783C100.087 27.5783 107.389 29.9818 122.274 29.6391L153.129 29.9797C153.129 29.9797 161.558 29.2096 175.739 29.3139C175.739 29.3139 201.069 33.8334 214.929 28.5538C214.929 28.5538 212.77 23.0651 215.686 22.7571C215.686 22.7571 226.341 20.0989 221.579 16.1965C220.094 15.4151 218.428 14.9701 216.715 14.8978C216.173 14.8834 215.638 14.7864 215.132 14.6107C211.68 13.3995 198.186 8.98516 189.55 10.6673C189.55 10.6673 183.321 11.577 178.594 10.7768L171.695 10.2405C171.695 10.2405 164.317 9.0597 156.566 11.4081C156.566 11.4081 143.888 14.4564 138.48 14.507C138.48 14.507 121.799 14.1458 116.8 18.6296C116.8 18.6296 112.733 21.0803 109.792 22.0531C108.962 22.3257 108.157 22.6606 107.385 23.0546C106.285 23.6023 104.766 24.3075 103.9 24.4047Z"
        fill="url(#paint1_linear_158_206)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_158_206"
          x1="20.1231"
          y1="21.8039"
          x2="71.0196"
          y2="27.7544"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C6E1F2" />
          <stop offset="1" stop-color="#2E9DDC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_158_206"
          x1="130.928"
          y1="32.4314"
          x2="329.759"
          y2="20.6372"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2D9CDB" />
          <stop offset="1" stop-color="#82A4E4" stop-opacity="0.79" />
        </linearGradient>
      </defs>
    </svg>
  );
};
